import { render } from "./TabDetail.vue?vue&type=template&id=f36d7456&scoped=true"
import script from "./TabDetail.vue?vue&type=script&lang=js"
export * from "./TabDetail.vue?vue&type=script&lang=js"

import "./TabDetail.vue?vue&type=style&index=0&id=f36d7456&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f36d7456"]])

export default __exports__